import { HttpClient, HttpMethods } from "@planzone/services";
import { Id, Identifiable, Organization, Planzone } from "@planzone/dto";

function getPlanzoneOrganisation(httpClient: HttpClient) {
  return (planzone: Identifiable<Planzone>) =>
    !!planzone.organization
      ? httpClient.sendHttpRequest<Identifiable<Organization>>({
          // @ts-ignore
          endpoint: `/api/organizations/${planzone.organization as Id}`,
          method: HttpMethods.GET,
        })
      : Promise.reject();
}

export { getPlanzoneOrganisation };
